// extracted by mini-css-extract-plugin
module.exports = {"pageHeader":"PageHeader-module_pageHeader__qDXnU","backButton":"PageHeader-module_backButton__2ma3D","rightSection":"PageHeader-module_rightSection__3u-qC"};